<template>
	<v-alert
		v-test="'scribe-access-archived-notice'"
		type="warning"
		variant="tonal"
		density="compact"
		rounded="lg"
		icon="mdi-alert-circle-outline"
		data-test-id="scribe-access-archived-notice">
		<div class="text-body-2">
			<strong>Your Sparks access is turned off for this organization.</strong>
			That's why your Sparks and reports aren't showing. Ask an admin in your organization to turn it back on.
		</div>
	</v-alert>
</template>

<script setup lang="ts">
	// LSP-17976: shown instead of an unexplained empty state when Scribe reports the user's
	// membership in the current organization is archived. See useScribeAccess.
</script>
